<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<template>
  <SubmenuDropdown
    :close-on-click="true"
    class="dropdown-icon"
    round
    data-testid="dashboard-nav-submenu"
    @mouseenter="$emit('tracking-event', {
      action: 'navDropdownHover',
      args: { label: 'Library' },
    })"
  >
    <div>
      <router-link
        class="icon-text-pair"
        :to="{ name: 'published', query: queryParams('published') }"
      >
        <DpplSvg file-name="icon-menu" />
        <span class="ml-2">
          Library
        </span>
      </router-link>
    </div>

    <NavigationMenu
      :columns="3"
      :link-sections="dashboardNavLinks"
      :get-query-param="queryParams"
      @tracking-event="(params) => $emit('tracking-event', params)"
    />
  </SubmenuDropdown>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import SubmenuDropdown from '@/components/editor/SubmenuDropdown.vue';
import NavigationMenu from '@/components/shared/NavigationMenu.vue';
import { libraryQueryParams } from '@/components/library/helpers';

export default {
  name: 'DashboardNavigationDropdown',
  components: {
    DpplSvg,
    NavigationMenu,
    SubmenuDropdown,
  },
  props: {
    dashboardNavLinks: { type: Array, default: () => [] },
  },
  emits: ['tracking-event'],

  methods: {
    queryParams(toMode) {
      return libraryQueryParams(toMode, this.$route);
    },
  },
};
</script>

<style scoped lang="less">
.icon-text-pair {
  display: flex;
  align-items: center;
  span {
    font-size: 15px;
    font-weight: 500;
  }
}
</style>
